import { useState, useEffect } from 'react'
import './Navbar.css'

interface NavbarProps {
  activeSection: string
}

const navItems = [
  { id: 'about', label: 'About', href: '#about' },
  { id: 'how-it-works', label: 'How It Works', href: '#how-it-works' },
  { id: 'services', label: 'Services', href: '#services' },
  { id: 'legacy-books', label: 'Journals', href: '#legacy-books' },
  { id: 'stories', label: 'Stories', href: '#stories' },
]

const Navbar: React.FC<NavbarProps> = ({ activeSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 24)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [isMenuOpen])

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsMenuOpen(false)
    }
    window.addEventListener('keydown', handleEscape)
    return () => window.removeEventListener('keydown', handleEscape)
  }, [])

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    const target = document.querySelector(href)
    if (target) {
      const offsetTop = (target as HTMLElement).offsetTop - 80
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      })
    }
    setIsMenuOpen(false)
  }

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    setIsMenuOpen(false)
  }

  return (
    <nav className={`navbar ${scrolled || isMenuOpen ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="#home" className="logo" onClick={handleLogoClick} aria-label="ECHO home">
          <span className="brand-lockup">
            <img src="/logo-mark.svg" alt="" className="brand-mark" />
            <span className="brand-word">
              <span className="brand-name">ECHO</span>
              <span className="brand-tag">Your Voice Lives</span>
            </span>
          </span>
        </a>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={item.href}
                className={activeSection === item.id ? 'active' : ''}
                onClick={(e) => handleNavClick(e, item.href)}
              >
                {item.label}
              </a>
            </li>
          ))}
          <li className="nav-menu-cta">
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>
              Talk with us
            </a>
          </li>
        </ul>
        <a href="#contact" className="nav-cta" onClick={(e) => handleNavClick(e, '#contact')}>
          Talk with us
        </a>
        <button
          className="nav-toggle"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className={isMenuOpen ? 'open' : ''}></span>
          <span className={isMenuOpen ? 'open' : ''}></span>
          <span className={isMenuOpen ? 'open' : ''}></span>
        </button>
      </div>
    </nav>
  )
}

export default Navbar
